const PRODUCT_NUMBER_RE =
  /^\s*(s|ART|SPR|)(?:\1|)\s*(\d\d\d)\.?\s*(\d\d\d)\.?\s*(\d\d)\s*$/;

/**
 * parse product number
 * @returns {Array} Array with [short_id, type]
 */
export function parseProduct(string = "") {
  if (typeof string !== "string") string = String(string ?? "");
  if (string.startsWith("SCI")) {
    // SCI type, return type as SCI and short_id as rest
    return [string.slice(3), "SCI"];
  }

  const canMatch = string && string.match; // RDT doesn't support ?. so we need to take small steps.
  const match = canMatch && string.match(PRODUCT_NUMBER_RE);

  if (!match) return ["", ""];

  const [, type, ...digits] = match;
  const short_id = digits.join("");
  return [
    short_id.length === 8 ? short_id : "",
    (type === "s" ? "SPR" : type) || "",
  ];
}

export const isValidItemNumber = (itemNumber: string) =>
  itemNumber && /^\d{8}$/.test(itemNumber);
